import React from 'react';
import { Dialog, FlatButton } from 'material-ui';
import R from 'ramda';

const CreateDraft = ({ onRequestClose, createTemplateDraft, open, sentPartners, isDummyAccount }) => (
  <Dialog
    open={open}
    title={isDummyAccount ? 'EDITING A RATE SHEET' : 'EDITING A TEMPLATE'}
    onRequestClose={onRequestClose}
    actions={[
      <FlatButton label="cancel" primary onTouchTap={onRequestClose} />,
      <FlatButton label="confirm" secondary onTouchTap={createTemplateDraft} />,
    ]}
  >
    {
      isDummyAccount ? (
        <div>
          <div>Please click CONFIRM if you’d like to edit this rate sheet.</div>
          <br/>
          <i>Note that we will create a new draft for you to work on your changes. Unless you accept the changes, your contract will include the changes.</i>
        </div>
      ) : (
        <div>
          <div>Please click CONFIRM if you’d like to edit this saved template.</div>
          <br/>
          {
            R.isEmpty(sentPartners) ?
              <i>Note that we’ll create a new template draft for you to work on your changes.</i>
              : <i>Note that we will create a new template draft for you to work on your changes. Unless you issue the changes, your partners will only see their original contract.</i>
          }
        </div>
      )
    }
  </Dialog>
);

export default CreateDraft;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/dialog-create-template-draft.jsx